/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";

export const SearchIconWrapper = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: 1px;
  padding-left: 16px;
  padding-right: 16px;
  color: rgb(197, 197, 197);
  width: 56px;
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.2s;
`;

const SearchButton = styled.button`
  border: 0px solid;
  -webkit-font-smoothing: antialiased;
  --bg-opacity: 1;
  margin: 0;
`;

export const ResetIconWrapper = styled(SearchButton)`
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  opacity: 0.75;
  padding-left: 16px;
  padding-right: 16px;
  fill: currentColor;
  color: #aeaeae;
  width: 56px;
  transition: all 0.2s ease-out;
`;

export const CancelButton = styled(SearchButton)`
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  line-height: inherit;
  height: 100%;
  padding-left: 16px;
  padding-right: 16px;
  color: rgb(153, 153, 153);
  transition: all 0.2s ease-out;
  font-family: inherit;
`;

export const Divider = styled.div`
  background-color: #e2e2e2;
  flex: none;
  height: 20px;
  width: 1px;
`;

export const StyledInput = styled.input`
  border: 0px solid;
  color: rbg(54, 57, 90);
  margin: 0;
  padding: 0;
  outline-offset: -2px;
  appearance: none;
  background-color: transparent;
  border-radius: 0;
  flex: 1 1 0%;
  height: 100%;
  line-height: normal;
  outline: 0;
  box-shadow: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.2s;

  font-size: 16px;
  line-height: 16px;
  ::placeholder {
    color: rbga(54, 57, 90, 0.3);
  }

  @media (max-width: ${DEVICE.small}) {
    /* must be 16px or greater to prevent autozoom on iOS */
    font-size: 16px;
  }
`;

export const SearchBarContainer = styled.div`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  background-color: #eeeeee;
`;

export const SearchBar = styled.div`
  font-size: 13px;
  font-family: "IBM Plex Mono", monospace;
  display: flex;
  align-items: center;
  height: 100%;
  outline: 0;
  width: 100%;
  height: 40px;
`;
